<template>
  <div class="form-bootstrapWizard">
    <ul class="bootstrapWizard">
      <li
        v-for="(label, index) in steps"
        :key="index"
        :class="{active: index === (currentStep - 1)}"
        :style="'width: ' + (100 / steps.length) + '%'"
      >
        <span class="step">{{ (index + 1) }}</span>
        <span class="title">{{ label }}</span>
      </li>
    </ul>
    <div class="clearfix" />
  </div>
</template>

<script>

export default {

  props: {
    currentStep: {
      required: true,
      type: Number
    },

    steps: {
      required: true,
      type: Array
    }
  }

}

</script>

<style scoped>
    .bootstrapWizard {
        margin: 20px 0;
        height: 60px;
    }
</style>
